// removed by extract-text-webpack-plugin
module.exports = {"main-title":"index-module__main-title___1Q9NY","mainTitle":"index-module__main-title___1Q9NY","line":"index-module__line___24is4","save-btn":"index-module__save-btn___3LyDb","saveBtn":"index-module__save-btn___3LyDb"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/graphql/UpdateBasicInfo/index.module.scss
// module id = 1621
// module chunks = 147